/* 🤖 this file was generated by svg-to-ts */
export const emperorIconSearch: {
  name: 'search';
  data: string;
} = {
  name: 'search',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.3639 3.636C18.6639 1.936 16.4039 1 13.9999 1C11.5959 1 9.33593 1.936 7.63593 3.636C4.61393 6.659 4.20193 11.311 6.38593 14.785L2.17193 19C1.39093 19.781 1.39093 21.047 2.17193 21.828C2.95293 22.61 4.21893 22.61 4.99993 21.828L9.21293 17.615C10.6339 18.513 12.2779 19 13.9999 19C16.4039 19 18.6649 18.065 20.3649 16.365C23.8719 12.856 23.8719 7.144 20.3639 3.636ZM13.9999 16C10.6859 16 7.99993 13.314 7.99993 10C7.99993 6.687 10.6859 4 13.9999 4C17.3139 4 19.9999 6.687 19.9999 10C19.9999 13.314 17.3129 16 13.9999 16Z"/></svg>`,
};
